import React, { Component } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button,
  CardContent,
  Columns,
  Column,
  MuiTitle,
  Dropdown,
  DropdownContent,
  DropdownItem,
} from 'src/ui/mui-ui-kit';
import { toast } from 'react-toastify';
import { UiToastAdapter, clearPhoneNumber, reduceServerErrors } from 'src/ui';
import { getToken } from 'src/auth';
import { getUser, fetchLoggedInUser } from 'src/user';
import {
  getAccount,
  fetchAccount,
  addAccountPerson,
  fetchAccountPeople,
} from 'src/account';
import { PeopleTable, AddPersonModal } from 'src/people';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PERSON_TYPE_OWNER, PERSON_TYPE_EMPLOYEE } from 'src/user/const';
import { ClientSidePagingManager } from 'src/api';

class StepContributors extends Component {
  state = {
    loading: true,
    isAddingOwner: false,
    isAddingEmployee: false,
    people: [],
  };

  constructor(props) {
    super(props);

    this.pagedPeople = new ClientSidePagingManager(
      this.props.fetchAccountPeople, // eslint-disable-line react/destructuring-assignment
      () => this.props.account.people, // eslint-disable-line react/destructuring-assignment
      people => {
        this.setState({ people });
      }
    );
  }

  async componentDidMount() {
    const { setNextEnabled, token, fetchLoggedInUser } = this.props;

    setNextEnabled(true);

    if (!token.isEmpty()) {
      await fetchLoggedInUser();

      this.loadData();
    }
  }

  dropdown = () => (
    <Dropdown
      isAlign="right"
      renderTrigger={
        <Button isColor="gradient-bright">
          <span>Add Person</span>
          <span className="icon">
            <FontAwesomeIcon icon={['fal', 'chevron-circle-down']} />
          </span>
        </Button>
      }
    >
      <DropdownContent>
        <DropdownItem tag="a" onClick={this.onToggleAddOwner}>
          Owner
        </DropdownItem>
        <DropdownItem tag="a" onClick={this.onToggleAddEmployee}>
          Employee
        </DropdownItem>
      </DropdownContent>
    </Dropdown>
  );

  onToggleAddPerson = type => {
    if (type === PERSON_TYPE_OWNER) {
      const { isAddingOwner } = this.state;
      this.setState({ isAddingOwner: !isAddingOwner });
    } else if (type === PERSON_TYPE_EMPLOYEE) {
      const { isAddingEmployee } = this.state;
      this.setState({ isAddingEmployee: !isAddingEmployee });
    }
  };

  onToggleAddOwner = () => {
    this.onToggleAddPerson(PERSON_TYPE_OWNER);
  };

  onToggleAddEmployee = () => {
    this.onToggleAddPerson(PERSON_TYPE_EMPLOYEE);
  };

  onCancelAddPerson = form => {
    this.setState({
      isAddingOwner: false,
      isAddingEmployee: false,
    });
    if (form) {
      form.reset();
    }
  };

  // eslint-disable-next-line consistent-return
  onSubmitPerson = async values => {
    const { user, addAccountPerson } = this.props;
    const { isAddingOwner } = this.state;

    await addAccountPerson({
      financialInstitutionId: user.financialInstitutionId,
      accountId: user.accountId,
      isAdmin: false,
      isSigner: false,
      ...values,
      type: isAddingOwner ? 'OWNER' : 'EMPLOYEE',
      primaryNumber: clearPhoneNumber(values.primaryNumber),
    });

    const { account } = this.props;

    if (account.isError()) {
      return reduceServerErrors(account);
    }
    this.onCancelAddPerson();
    this.pagedPeople.refresh();
    toast(UiToastAdapter('Person added successfully!', 'success'));
  };

  async loadData() {
    const { user, fetchAccount } = this.props;

    this.setState({ loading: true });

    if (user.accountId) {
      await fetchAccount(user.accountId);

      const { account } = this.props;
      if (account.isError()) {
        toast(UiToastAdapter(account.errorMessage().detail, 'danger'));
      }

      await this.pagedPeople.fetch({ accountId: user.accountId });
    }
    this.setState({ loading: false });
  }

  render() {
    const {
      account: { businessName },
      user: { financialInstitutionName },
    } = this.props;
    const { loading, isAddingEmployee, isAddingOwner, people } = this.state;

    return (
      <CardContent className="step-contributors">
        <div className="content">
          <MuiTitle hasTextAlign="centered" isSize="3" hasTextColor="primary">
            Add Contributors
          </MuiTitle>
          <p className="leading has-text-centered has-text-grey-medium-dark">
            Here you can add other users that will help you filling all
            information required for the business. You can skip this step and
            add people later on through the{' '}
            <b className="has-text-info">People</b> section.
          </p>
        </div>
        <Columns>
          <Column hasTextAlign="right">
            <Dropdown
              isAlign="right"
              renderTrigger={
                <Button isColor="gradient-bright">
                  <span>Add Person</span>
                  <span className="icon">
                    <FontAwesomeIcon icon={['fal', 'chevron-circle-down']} />
                  </span>
                </Button>
              }
            >
              <DropdownContent>
                <DropdownItem tag="a" onClick={this.onToggleAddOwner}>
                  Owner
                </DropdownItem>
                <DropdownItem tag="a" onClick={this.onToggleAddEmployee}>
                  Employee
                </DropdownItem>
              </DropdownContent>
            </Dropdown>
          </Column>
        </Columns>
        <PeopleTable
          loading={loading}
          people={people}
          minRows={3}
          hidePrev
          hideNext
          paging={this.pagedPeople}
          renderButton={this.dropdown()}
          hideNoDataComponent
        />
        <AddPersonModal
          type={PERSON_TYPE_OWNER}
          isActive={isAddingOwner}
          onCancel={this.onCancelAddPerson}
          onSubmit={this.onSubmitPerson}
          businessName={businessName || ''}
          financialInstitutionName={financialInstitutionName || ''}
        />
        <AddPersonModal
          type={PERSON_TYPE_EMPLOYEE}
          isActive={isAddingEmployee}
          onCancel={this.onCancelAddPerson}
          onSubmit={this.onSubmitPerson}
          businessName={businessName || ''}
          financialInstitutionName={financialInstitutionName || ''}
        />
      </CardContent>
    );
  }
}

StepContributors.propTypes = {
  setNextEnabled: propTypes.func.isRequired,
  fetchLoggedInUser: propTypes.func.isRequired,
  fetchAccount: propTypes.func.isRequired,
  addAccountPerson: propTypes.func.isRequired,
  fetchAccountPeople: propTypes.func.isRequired,
  token: propTypes.object.isRequired,
  user: propTypes.object.isRequired,
  account: propTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    token: getToken(state),
    user: getUser(state),
    account: getAccount(state),
  };
}

const connectedStepContributors = connect(mapStateToProps, {
  fetchLoggedInUser,
  fetchAccount,
  addAccountPerson,
  fetchAccountPeople,
})(StepContributors);

export { connectedStepContributors as StepContributors };
